import { Accordion, type AccordionItem } from "components/shared/Accordion";
import { ConnectWithUsButton } from "../components/ConnectWithUsButton";
import { SchoolSection } from "../components/SchoolSection";
import { SectionTitle } from "../components/SectionTitle";
import { useSchoolLocal } from "../useSchoolLocal";
import { ProgressSharing } from "./ProgressSharing";

export const WhatWeOffer = () => {
  const { t, tObject } = useSchoolLocal();

  return (
    <SchoolSection contentClassName="py-14 md:py-20">
      <SectionTitle className="mb-2">{t("whatWeOffer.title")}</SectionTitle>
      <p className="mb-7 max-w-[560px] text-[#3D3C56]">
        {t("whatWeOffer.lead")}
      </p>
      <div className="max-w-[720px]">
        <Accordion items={tObject<AccordionItem[]>("whatWeOffer.offers")} />
      </div>
      <ProgressSharing />
      <div className="mt-7 flex justify-end">
        <ConnectWithUsButton className="w-full md:w-fit" />
      </div>
    </SchoolSection>
  );
};
